import React, { useState, useEffect } from "react";
import { fetchData } from "../../Components/common/utils";
import MainLoader from "../../Components/MainLoader";
import { countryListLocal } from "../../Components/CountryList";
import { Select } from "@mantine/core";
import { RichTextEditor, Link } from '@mantine/tiptap';
import { useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import { State, City } from "country-state-city";
import '@mantine/core/styles.css';
import '@mantine/tiptap/styles.css';
import { data } from "react-router-dom";
function AddShop() {
    const [categoryList, setCategoryList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [cityStateList, setCityStateList] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        shop_name: '',
        category_id: '',
        contact_person: '',
        email: '',
        phone: '',
        website_url: '',
        city: '',
        city_select: null,
        state: '',
        country: '167',
        address: '',
        description: '',
        long_description: '',
        opening_hours: '',
        category_of_shop: '',
        shop_service: '',
        shop_image: null,
    });

    const [errors, setErrors] = useState({});
    useEffect(() => {
        const states = State.getStatesOfCountry('PK');
        setStateList(states)
        const fetchApiData = async () => {
            const url = "api/company/logo"; // Change this to your category API
            const result = await fetchData(url);
            const service = "api/service";
            const serviceres = await fetchData(service);
            if (result && result.data) {
                setCategoryList(result.data);
            }
            if (serviceres && serviceres.data) {
                const ser = serviceres.data.filter(item => item.slug === 'find-service-providers');
                if (ser.length > 0) {
                    setFormData((prev) => ({
                        ...prev,
                        shop_service: ser[0].id
                    }));
                }
                setServiceList(ser);
            }
        };
        fetchApiData();
        // GetCountries();
        GetCitiesStates();
    }, []);

    const GetCountries = async () => {
        try {
            const response = await fetch("https://admin.energybazzar.com/api/getCountry", {
                method: "GET",

            });
            const result = await response.json();
            setCountryList(result?.cities || []);

        } catch (error) {
            console.error("Error:", error);
        }
    }
    const GetCitiesStates = async () => {
        const formDataSet = new FormData();
        formDataSet.append("id", formData.country);
        try {
            const response = await fetch("https://admin.energybazzar.com/api/getCities", {
                method: "POST",
                body: formDataSet
            });
            const result = await response.json();
            debugger
            setCityStateList(result?.cities || []);
            const uniqueStates = [
                ...new Map(result?.cities.map(item => [item.state.id, {
                    id: item.state.id,
                    name: item.state.name
                }])).values()
            ];
            setStateList(uniqueStates);
        } catch (error) {
            console.error("Error:", error);
        }
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (errors[name]) {
            setErrors((prev) => {
                const updatedErrors = { ...prev };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
        // if (name === 'country') {
        //     const scountry = countryListLocal.item.find(item => item.name.common === value);
        //     const states = value ?  State.getStatesOfCountry(scountry.cca2) : [];
        //     console.log(states)
        //     setStateList(states)
        // }
        if (name === 'state') {
            const cities = cityStateList.filter(item => item.state_id === Number(value));
            console.log(cities)
            setCityList(cities)
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: name === "banner_images" ? Array.from(files) : files[0]
        }));
    };

    const validate = () => {
        const newErrors = {};
        const requiredFields = [
            "shop_name",
            "category_id",
            "contact_person",
            "email",
            "phone",
            'city_select',
            "city",
            "state",
            "country",
            "address",
            "description",
            'category_of_shop',
            "opening_hours",
            "shop_image",
            "shop_service",
        ];

        requiredFields.forEach(field => {
            if (!formData[field] || (Array.isArray(formData[field]) && formData[field].length === 0)) {
                newErrors[field] = `${field.replace("_", " ")} is required`;
            }
        });

        if (formData.email && !formData.email.includes("@")) {
            newErrors.email = "Valid email is required";
        }

        if (formData.phone && !formData.phone.match(/^\d{10,15}$/)) {
            newErrors.phone = "Valid phone number required (10-15 digits)";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        setLoading(true)
        const formDataSet = new FormData();

        // Append fields in order shown in images
        formDataSet.append("shop_name", formData.shop_name);
        formDataSet.append("category_id", formData.category_id);
        formDataSet.append("contact_person", formData.contact_person);
        formDataSet.append("email", formData.email);
        formDataSet.append("phone", formData.phone);
        formDataSet.append("website_url", formData.website_url);
        formDataSet.append("address", formData.address);
        formDataSet.append("city_id", formData.city);
        formDataSet.append("state_id", formData.state);
        formDataSet.append("country_id", formData.country);

        formDataSet.append("description", formData.description);
        formDataSet.append("long_description", formData.long_description);
        formDataSet.append("opening_hours", formData.opening_hours);
        formDataSet.append("category_of_shop", formData.category_of_shop);
        formDataSet.append("service_id", formData.shop_service);

        if (formData.shop_image) {
            formDataSet.append("shop_image", formData.shop_image);
        }

        // if (formData.banner_images && formData.banner_images.length > 0) {
        //     formData.banner_images.forEach((file, index) => {
        //         formDataSet.append("banner_images", file); // If backend expects array: `banner_images[]`
        //     });
        // }


        try {
            const response = await fetch("https://admin.energybazzar.com/api/shop/store", {
                method: "POST",
                body: formDataSet,
            });
            const result = await response.json();
            setLoading(false)
            if (result.status === true) {
                setSuccessMessage(result.message);
                setFormData({
                    shop_name: '',
                    category_id: '',
                    contact_person: '',
                    email: '',
                    phone: '',
                    website_url: '',
                    city: '',
                    state: '',
                    country: '167',
                    address: '',
                    description: '',
                    long_description: '',
                    opening_hours: '',
                    category_of_shop: '',
                    shop_image: null,
                })
            } else {
                setErrorMessage(result.message)
            }
        } catch (error) {
            setLoading(false)
            console.error("Error submitting form:", error);
            setErrorMessage('Error submitting form please try later.')
        }
    };

    const editor = useEditor({
        extensions: [
            StarterKit,
            Underline,
            Link,
            TextAlign.configure({ types: ['heading', 'paragraph'] }),
        ],
        onUpdate: ({ editor }) => {
            const html = editor.getHTML();
            setFormData((prev) => ({
                ...prev,
                long_description: html
            }));
        },
    });
    const selectCitySelect = (value) => {
        const fcity = cityList.find(item => item.name === value)
        setFormData((prev) => ({
            ...prev,
            city_select: value,
            city: fcity?.id ? fcity?.id : ''
        }));
    }
    return (
        <div className="container py-5">
            {loading && <MainLoader />}
            <div className="card p-4">
                <h2 className="mb-4 text-center text-primary">Add Your Shop</h2>

                <form onSubmit={handleSubmit}>
                    <div className="row g-3 form-section">
                        {[
                            { id: 'shop_name', label: 'Shop Name' },
                            { id: 'contact_person', label: 'Contact Person' },
                            { id: 'email', label: 'Email', type: 'email' },
                            { id: 'phone', label: 'Phone' },
                            { id: 'website_url', label: 'Website URL', type: 'text' },
                        ].map(({ id, label, type = 'text' }) => (
                            <div className="col-md-6" key={id}>
                                <div className="form-floating">
                                    <input
                                        type={type}
                                        className={`form-control ${errors[id] ? 'is-invalid' : ''}`}
                                        id={id}
                                        name={id}
                                        placeholder={label}
                                        value={formData[id]}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor={id}>{label}</label>
                                    {errors[id] && <div className="invalid-feedback">{errors[id]}</div>}
                                </div>
                            </div>
                        ))}
                        <div className="col-md-6">
                            <div className="form-floating">
                                <select
                                    className={`form-select ${errors.country ? 'is-invalid' : ''}`}
                                    name="country"
                                    value={formData.country}
                                    onChange={handleChange}
                                    disabled
                                >
                                    <option value="" selected>Pakistan</option>
                                    {countryList.sort((a, b) => a.name.localeCompare(b.name)).map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))}
                                </select>
                                <label htmlFor="country">Country</label>
                                {errors.country && <div className="invalid-feedback">{errors.country}</div>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-floating">
                                <select
                                    className={`form-select ${errors.state ? 'is-invalid' : ''}`}
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                >
                                    <option value="">Select State</option>
                                    {stateList.map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))}
                                </select>
                                <label htmlFor="state">State</label>
                                {errors.state && <div className="invalid-feedback">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="border px-2 rounded">
                                <label className="small text-muted">City</label>
                                <Select
                                    className="no-border-select"
                                    placeholder="Select City"
                                    searchable
                                    value={formData.city_select}
                                    onChange={selectCitySelect}
                                    data={cityList.sort((a, b) => a.name.localeCompare(b.name)).map((item) => ({ label: item.name, value: item.name }))}
                                />
                                {/* <select
                                    className={`form-select ${errors.city ? 'is-invalid' : ''}`}
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                >
                                    <option value="">Select City</option>
                                    {cityList.sort((a, b) => a.name.localeCompare(b.name)).map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))}
                                </select>
                                <label htmlFor="city">City</label> */}
                                {errors.city && <div className="invalid-feedback">{errors.city}</div>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-floating">
                                <select
                                    className={`form-select ${errors.category_id ? 'is-invalid' : ''}`}
                                    name="category_id"
                                    value={formData.category_id}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Category</option>
                                    {categoryList.map((item) => (
                                        <option key={item.id} value={item.id}>{item.title}</option>
                                    ))}
                                </select>
                                <label htmlFor="category_id">Category</label>
                                {errors.category_id && <div className="invalid-feedback">{errors.category_id}</div>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-floating">
                                <select
                                    className={`form-select ${errors.category_of_shop ? 'is-invalid' : ''}`}
                                    name="category_of_shop"
                                    value={formData.category_of_shop}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Type</option>
                                    <option value='supplier'>Supplier</option>
                                    <option value='technicians'>Technicians</option>
                                    <option value='installer'>Installer</option>
                                    <option value='retailer'>Retailer</option>
                                    <option value='importer-exporter'>Importer/Exporter</option>
                                    <option value='franchise-dealership'>Franchise/Dealership</option>
                                    <option value='electrician'>Electrician</option>
                                    <option value='mechanic'>Mechanic</option>
                                    <option value='manufacturer'>Manufacturer</option>
                                </select>
                                <label htmlFor="category_of_shop">Business Type</label>
                                {errors.category_of_shop && <div className="invalid-feedback">{errors.category_of_shop}</div>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-floating">
                                <select
                                    className={`form-select ${errors.shop_service ? 'is-invalid' : ''}`}
                                    name="shop_service"
                                    value={formData.shop_service}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Service</option>
                                    {serviceList.map((item, index) => (
                                        <option key={index} value={item.id}>{item.title}</option>
                                    ))}
                                </select>
                                <label htmlFor="shop_service">Shop Belong</label>
                                {errors.shop_service && <div className="invalid-feedback">{errors.shop_service}</div>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-floating">
                                <textarea
                                    className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                                    id="address"
                                    name="address"
                                    placeholder="Address"
                                    value={formData.address}
                                    onChange={handleChange}
                                />
                                <label htmlFor="address">Address</label>
                                {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                            </div>
                        </div>
                    </div>

                    {/* Shop Details */}
                    <div className="form-section mt-3">
                        <h5 className="text-secondary">Shop Details</h5>
                        <div className="row g-3">
                            {['description', 'opening_hours'].map((field) => (
                                <div className="col-md-6" key={field}>
                                    <div className="form-floating">
                                        <textarea
                                            className={`form-control ${errors[field] ? 'is-invalid' : ''}`}
                                            placeholder={field}
                                            id={field}
                                            name={field}
                                            value={formData[field]}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor={field}>{field.replace("_", " ")}</label>
                                    </div>
                                </div>
                            ))}
                            <div className="col-md-12">
                                <h5 className="text-secondary">Shop Long Details</h5>
                                <RichTextEditor editor={editor}>
                                    <RichTextEditor.Toolbar sticky stickyOffset="var(--docs-header-height)">
                                        <RichTextEditor.ControlsGroup>
                                            <RichTextEditor.Bold />
                                            <RichTextEditor.Italic />
                                            <RichTextEditor.Underline />
                                            <RichTextEditor.Strikethrough />
                                            <RichTextEditor.ClearFormatting />
                                            <RichTextEditor.Code />
                                        </RichTextEditor.ControlsGroup>

                                        <RichTextEditor.ControlsGroup>
                                            <RichTextEditor.H1 />
                                            <RichTextEditor.H2 />
                                            <RichTextEditor.H3 />
                                            <RichTextEditor.H4 />
                                        </RichTextEditor.ControlsGroup>

                                        <RichTextEditor.ControlsGroup>
                                            <RichTextEditor.Blockquote />
                                            <RichTextEditor.Hr />
                                            <RichTextEditor.BulletList />
                                            <RichTextEditor.OrderedList />
                                        </RichTextEditor.ControlsGroup>

                                        <RichTextEditor.ControlsGroup>
                                            <RichTextEditor.Link />
                                            <RichTextEditor.Unlink />
                                        </RichTextEditor.ControlsGroup>

                                        <RichTextEditor.ControlsGroup>
                                            <RichTextEditor.AlignLeft />
                                            <RichTextEditor.AlignCenter />
                                            <RichTextEditor.AlignJustify />
                                            <RichTextEditor.AlignRight />
                                        </RichTextEditor.ControlsGroup>

                                        <RichTextEditor.ControlsGroup>
                                            <RichTextEditor.Undo />
                                            <RichTextEditor.Redo />
                                        </RichTextEditor.ControlsGroup>
                                    </RichTextEditor.Toolbar>

                                    <RichTextEditor.Content />
                                </RichTextEditor>
                            </div>
                        </div>
                    </div>

                    {/* File Uploads */}
                    <div className="form-section mt-3">
                        <h5 className="text-secondary">Upload Image</h5>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label htmlFor="shop_image" className="form-label">Shop Logo</label>
                                <input className={`form-control ${errors['shop_image'] ? 'is-invalid' : ''}`} type="file" name="shop_image" onChange={handleFileChange} />
                            </div>
                        </div>
                    </div>

                    <div className="text-center">
                        {successMessage && (
                            <div class="alert alert-success mt-4" role="alert">
                                {successMessage}
                            </div>
                        )}
                        {errorMessage && (
                            <div class="alert alert-danger mt-4" role="alert">
                                {errorMessage}
                            </div>
                        )}
                        <button type="submit" className="btn btn-primary btn-lg mt-3">Add Shop</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddShop;
